// EDIT BY ALI FOR DARK MODE - Added useTheme import
import styled from "@emotion/styled";
import {Box, Card, Typography, useTheme} from "@mui/material";

// EDIT BY ALI FOR DARK MODE - Updated CardBoundary to use theme colors
const CardBoundary = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(88, 89, 91, 0.2)"}`,
  backgroundColor: theme.palette.widget.inactive,
  borderRadius: "8px",
  width: "500px",
  padding: "15px",
  transition: "transform 0.15s ease-in-out",
}));


const NoInfoCard = () => {
  // EDIT BY ALI FOR DARK MODE - Added useTheme hook
  const theme = useTheme();
  return (
    <CardBoundary variant="outlined">
      <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        {/* EDIT BY ALI FOR DARK MODE - Updated Typography to use theme colors */}
        <Typography variant="subtitle2" sx={{ color: theme.palette.mode === "dark" ? "#FFFFFF" : undefined }}>
          There is no information for this category
        </Typography>
      </Box>
    </CardBoundary>
  )
}

export default NoInfoCard